module.exports = __webpack_public_path__ + "img/copy-to-clipboard.d414fbd0.svg";